<div class="page-header">
  <!-- Back Button -->


  <!-- Header Content -->
  <div class="header-content">
    <div class="header-info">
      <h2>{{ title }}</h2>
      @if (subtitle) {
        <p class="subtitle">{{ subtitle }}</p>
      }
       <!-- Breadcrumb Navigation -->
  @if (breadcrumbs && breadcrumbs.length > 0) {
    <div class="breadcrumb-container">
      <nav class="breadcrumb-nav">
        <!-- Home Icon -->
        <mat-icon class="breadcrumb-home-icon">home</mat-icon>

        @for (breadcrumb of breadcrumbs; track breadcrumb.label; let isLast = $last) {
          <span class="breadcrumb-separator">></span>
          <div class="breadcrumb-item" [class.current]="isLast">
            @if (breadcrumb.link && !isLast) {
              <a [routerLink]="breadcrumb.link" class="breadcrumb-link">{{ breadcrumb.label }}</a>
            } @else {
              <span class="breadcrumb-text">{{ breadcrumb.label }}</span>
            }
          </div>
        }
      </nav>
    </div>
  }
    </div>
    @if (showDate) {
      <div class="header-date">
        <button mat-stroked-button color="primary">
          <mat-icon>calendar_today</mat-icon>
          {{ today | date: 'EEE MMM d y, h:mm a' }}
        </button>
      </div>
    }
  </div>
</div>
